"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var populateContactPicker_1 = require("../actions/populateContactPicker");
var mobx_react_1 = require("mobx-react");
var Callout_1 = require("office-ui-fabric-react/lib/Callout");
var List_1 = require("office-ui-fabric-react/lib/List");
var FindRecipient_1 = require("owa-recipient-common/lib/components/FindRecipient");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var userAgent_1 = require("owa-user-agent/lib/userAgent");
var React = require("react");
var styles = require('./ContactPickerPane.scss');
var classNames = require('classnames/bind').bind(styles);
var ContactPickerPane = /** @class */ (function (_super) {
    tslib_1.__extends(ContactPickerPane, _super);
    function ContactPickerPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dismissContactPicker = function () {
            _this.props.dismissContactPickerAction();
        };
        _this.onLayerMounted = function () {
            if (_this.props.viewState.maxForSession != _this.props.viewState.contacts.length) {
                populateContactPicker_1.default(_this.props.viewState);
            }
        };
        _this.renderSingleContact = function (item, index) {
            var contact = item;
            if (contact.EmailAddress) {
                return (React.createElement(FindRecipient_1.default, { key: contact.EmailAddress.EmailAddress, findRecipient: contact, isHighlighted: false, addRecipientAction: _this.props.addRecipientAction }));
            }
            else {
                return null;
            }
        };
        return _this;
    }
    ContactPickerPane.prototype.render = function () {
        var _a = this.props, findControlGetter = _a.findControlGetter, viewState = _a.viewState;
        return (React.createElement(Callout_1.Callout, { className: classNames(styles.callout, {
                animationStop: userAgent_1.isBrowserEdge() /* see VSO:13872 Remove on release of RS3 */,
            }), gapSpace: 10, onDismiss: this.dismissContactPicker, onLayerMounted: this.onLayerMounted, target: findControlGetter(), isBeakVisible: false, setInitialFocus: false, directionalHint: 4 /* bottomLeftEdge */ },
            React.createElement("div", { className: styles.suggestedContactsHeaderBox },
                React.createElement("span", { className: styles.suggestedContactsText }, owa_common_strings_1.default.contactPickerYourContacts)),
            viewState.contacts.length != 0 && (React.createElement("div", { className: classNames(styles.scrollContainer, 'customScrollBar'), "data-is-scrollable": true },
                React.createElement(List_1.List, { items: viewState.contacts, onRenderCell: this.renderSingleContact })))));
    };
    ContactPickerPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], ContactPickerPane);
    return ContactPickerPane;
}(React.Component));
exports.default = ContactPickerPane;
//# sourceMappingURL=ContactPickerPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-contact-picker/lib/components/ContactPickerPane.js
// module id = 5204
// module chunks = 99